module.exports = __webpack_public_path__ + "static/img/04scratch.ca208045.png";